import { useTranslation, Trans } from 'react-i18next'
import { Box, Button, Dialog, List, Stack, Text } from '@machobear/design-system'
import { SuccessIcon } from '@/components/icons'
import VerifiedBadge from '@/components/verified-badge'
import { ListCheckmark } from '@/components/icons'

const VerificationSuccessModal = ({ listingId, history, open, onClose }) => {
  const { t } = useTranslation()

  const handleClick = () => {
    history.replace(`/listing/${listingId}`)
    onClose()
  }

  return (
    <Dialog
      id="MaxAttemptsModal"
      illustration={<SuccessIcon />}
      title={t('l.verify_listing.view.verify_code_success.title', 'Listing verified!')}
      open={open}
      onClose={onClose}
      width="xsmall"
    >
      <Stack space="medium">
        <Text>
          {t(
            'l.verify_listing.view.verify_code_success.text',
            'Thank you for keeping our rental community safe. Enjoy the benefits of having a verified listing such as:'
          )}
        </Text>
        <List type="icon" icon={<ListCheckmark />}>
          <Text>
            <Trans i18nKey="l.verify_listing.view.verify_code_list_1.text">
              A verified badge{' '}
              <VerifiedBadge type="listing" verified height={20} width={20} bottom={-4} /> appearing
              next to your listing <br />
            </Trans>
          </Text>
          <Text>
            <Trans i18nKey="l.verify_listing.view.verify_code_list_2.text">
              Receiving up to <strong>5x</strong> the engagement
            </Trans>
          </Text>
        </List>
      </Stack>
      <Box paddingTop="large" onClick={handleClick}>
        <Button>{t('r.verify_listing.view.verify_code_success.button', 'Got it')}</Button>
      </Box>
    </Dialog>
  )
}

export default VerificationSuccessModal
